/**
 * View more text block — animates the *closing* half of its <details>.
 * Markup: blocks/view-more-text.php, blocks/main-block-sticky-side-blocks.php
 * (same "View more"/"View less" toggle, reused as-is rather than duplicated).
 *
 * Same technique as src/js/collapsed-text.js: opening animates off the
 * native [open] attribute via pure CSS (group-open:… utilities in the block
 * template), no JS needed. Closing doesn't — the browser hides a <details>'s
 * content the instant [open] is removed, before a transition gets a chance
 * to run. So on a close click this forces the row/icon/label to their closed
 * values via inline style (which overrides the group-open: class rules while
 * [open] is still present), waits for that transition to actually finish,
 * then removes [open]. Without JS the block still opens/closes instantly via
 * the native attribute — this is a pure enhancement, not a dependency.
 */

const TRANSITION_FALLBACK = 400; // ms — safety net if transitionend never fires

function afterCollapse( content, done ) {
	let fired = false;
	const finish = () => {
		if ( fired ) {
			return;
		}
		fired = true;
		content.removeEventListener( 'transitionend', onEnd );
		done();
	};
	const onEnd = ( event ) => {
		if ( event.target === content && event.propertyName === 'grid-template-rows' ) {
			finish();
		}
	};
	content.addEventListener( 'transitionend', onEnd );
	setTimeout( finish, TRANSITION_FALLBACK );
}

document.querySelectorAll( '.block-view_more_text details, .block-main_block_sticky_side_blocks details' ).forEach( ( details ) => {
	const summary = details.querySelector( ':scope > summary' );
	const content = details.querySelector( ':scope > .js-view-more-text-content' );
	const icon = details.querySelector( '.js-view-more-text-chevron' );
	const labelMore = details.querySelector( '.js-view-more-text-label-more' );
	const labelLess = details.querySelector( '.js-view-more-text-label-less' );
	if ( ! summary || ! content ) {
		return;
	}

	summary.addEventListener( 'click', ( event ) => {
		if ( ! details.open ) {
			return; // opening — let the browser + CSS handle it natively
		}
		event.preventDefault();

		content.style.gridTemplateRows = '0fr';
		if ( icon ) {
			icon.style.rotate = '0deg'; // Tailwind's rotate-* utilities set the standalone `rotate` property, not `transform`
		}
		if ( labelMore ) {
			labelMore.style.display = '';
		}
		if ( labelLess ) {
			labelLess.style.display = 'none';
		}

		afterCollapse( content, () => {
			details.open = false;
			content.style.gridTemplateRows = '';
			if ( icon ) {
				icon.style.rotate = '';
			}
			if ( labelMore ) {
				labelMore.style.display = '';
			}
			if ( labelLess ) {
				labelLess.style.display = '';
			}
		} );
	} );
} );
